import React, { Component } from "react";
import AppSDK from "@growthos/ui-app-sdk";
import { withRouter } from "../../ComponentWithRouterProp";
import { TextInputSkeleton } from "carbon-components-react";

import { onStateChange } from "events";
import "./modal.scss";
import ModalHelpers from "./ModalHelpers";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import { putActivationData } from "../../Flux/Actions/MasterCampaignActions";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import Loading from "../../Components/LoadingSpinner";
import Modal from "@acadia-ui/modal";
import Button from "@acadia-ui/button";
import Dropdown from "@acadia-ui/dropdown";
import { putFilterData } from "../../Flux/Actions/BookFilterActions";
import { fetchActivationHeaders, getPlatformAdvertisers } from "../../Flux/Actions/MasterCampaignActions";
import "./CreateActivationPlatform.scss";
import { showToast, ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import AccessPermissions from "../../Components/FormBuilder/AccessPermissions";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	advertiser: null,
	isFormDataValid: false
};

const formEl = "create__activation";

class CreateActivationPlatform extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			selectedPlatform: null,
			activationConfig: [],
			isDataKeyFieldsLoaded: false,
			...initialState,
			permissionedOptions: {}
		};
	}

	componentDidMount() {
		this.props.apRef(this);
		MasterCampaignsStore.on("error_activation", this.handleErrors);
		MasterCampaignsStore.on("activation_success", this.handleSuccess);
		MasterCampaignsStore.on("activation__errors__reset", this.handleReset);

		MasterCampaignsStore.on("activationConfig", this.activationPlatformChanged);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.selectedPlatform && prevState.selectedPlatform?.label !== this.state.selectedPlatform?.label) {
			const { value, label } = this.state.selectedPlatform;
			putFilterData("platform", { value, label });

			const filterChoices = BookFiltersStore.getChoicesState();
			MasterCampaignsStore.resetPlatformAdvertisers();
			const config = {
				masterPlatformID: value
			};
			getPlatformAdvertisers(config);

			fetchActivationHeaders(filterChoices, this.state.selectedPlatform?.HierarchyLevelID).then(() => {
				this.setState({ isDataKeyFieldsLoaded: true });
			});
		}
	}

	componentWillUnmount() {
		this.props.apRef(undefined);
		MasterCampaignsStore.removeListener("error_activation", this.handleErrors);
		MasterCampaignsStore.removeListener("activation_success", this.handleSuccess);
		MasterCampaignsStore.removeListener("activation__errors__reset", this.handleReset);
		MasterCampaignsStore.removeListener("activationConfig", this.activationPlatformChanged);
	}

	activationPlatformChanged = () => {
		this.setState({ activationConfig: MasterCampaignsStore.getActivationConfig() }, () => {
			this.setState({ loading: false });
			this.setInitialFormData();
		});
	};

	handleSuccess = () => {
		showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="New activation campaign has been added to the system." timed={5000} />);

		this.setState({ loading: false }, () => {
			this.triggerOpenClose();
			this.props.refresh();
			this.handleNavigateToWorkbook();
		});
	};

	handleNavigateToWorkbook = () => {
		const newCampaign = MasterCampaignsStore.getNewlyCreatedActivationCampaign();
		if (newCampaign) {
			const contextValues = BookFiltersStore.getContextValues();
			const { MasterPlatformID, CampaignUniqueCode, ParentUniqueIDcode, HierarchyLevelId } = newCampaign || {};
			const url = new URL(`${window.location.origin}/Workbook/`);

			const queryParams = {
				context_id: contextValues.contextId,
				agency: contextValues?.agency?.name,
				client: contextValues?.client?.name,
				region: contextValues?.region?.name,
				country: contextValues?.country?.name,
				hierarchyLevelID: HierarchyLevelId,
				platformID: MasterPlatformID,
				campaignID: CampaignUniqueCode,
				masterCampaignID: ParentUniqueIDcode
			};

			Object.entries(queryParams).forEach(([key, val]) => url.searchParams.append(key, val));
			window.open(url.toString(), "_blank");
		}
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = MasterCampaignsStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const activationErrors = errors.activation;
				const type = "create activationplatform";
				this.setState({ errors: activationErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
				});
			}
		});
	};

	setInitialFormData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.state.activationConfig);
		for (const dataBucket of configObjs) {
			for (const field of dataBucket[1]) {
				if (field.Name && field?.FieldType != "Hidden") {
					this.state.formData[field.Name] = { disabled: false, parentName: null, value: "" };
				}
			}
		}
	};

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled) {
					isValid = false;
				}
			}
		}
		if (Object.keys(this.props.permissionedDataKeys).length) {
			const selectedPermissions = [];
			Object.values(this.state.permissionedOptions).forEach((dataValues) => {
				selectedPermissions.push(...dataValues);
			});
			if (!selectedPermissions.length) {
				isValid = false;
			}
		}
		if (!this.state.selectedPlatform) {
			isValid = false;
		}

		this.setState({ isFormDataValid: isValid });
	};

	updateState = (dataConfig, name, value, id, dataType, calc) => {
		if (this.state.loading === false) {
			const formattedValue = value;
			// The reference to THIS is used to update the proper state
			const filters = BookFiltersStore.getChoicesState();
			const platformName = filters.platform.label;
			let invalidInput = false;
			if (platformName === "DV360") {
				const KPI_GOAL_CURRENCY = ["385", "382", "381", "386", "380", "389"];
				const KPI_GOAL_PERCENTAGE = ["391", "387", "383", "388", "392", "384", "390"];
				const { postData } = this.state;
				const campaignData = postData.CampaignData;
				if (name === "KPIGoalDetails") {
					if (KPI_GOAL_CURRENCY.includes(this.state.formData.KPIGoal?.value?.value?.toString())) {
						if (parseFloat(value) === 0) {
							invalidInput = true;
							const { formData } = this.state;
							if (formData.KPIGoalDetails) {
								formData.KPIGoalDetails.value = "";
							}
							delete campaignData.KPIGoalDetails;
							postData.CampaignData = campaignData;
							this.setState({ formData, postData });
						}
					} else if (KPI_GOAL_PERCENTAGE.includes(this.state.formData.KPIGoal?.value?.value?.toString())) {
						if (parseInt(value, 10) > 100) {
							invalidInput = true;
						}
					}
				} else if (name === "KPIGoal") {
					if (value === null) {
						delete campaignData.KPIGoalDetails;
						postData.CampaignData = campaignData;
					}
				} else if (name === "CampaignGoal") {
					if (value === null) {
						delete campaignData.KPIGoalDetails;
						delete campaignData.KPIGoal;
						postData.CampaignData = campaignData;
					}
				}
			}

			if (!invalidInput) {
				UpdateStateHelper.update(dataConfig, name, formattedValue, id, dataType, true, formEl, this, false, this.state.activationConfig, false, this.isValidFormData);
			}
		}
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			const updatedData = putActivationData(this.postObject);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.state.activationConfig.TaxonomyData) {
				this.state.activationConfig.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;

			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			const filters = BookFiltersStore.getChoicesState();
			const MasterUniqueCodeID = this.props.selectedMasterCampaignID || MasterCampaignsStore.getMasterCampaignUniqueID();
			/* Config will hold the ID's of the filters */
			// const AgencyID = filters.agency.value;
			// const ClientID = filters.clients.value;
			// const CountryID = filters.country.value;
			const PlatformID = filters.platform.value;
			// const RegionID = filters.region.value;
			if (postData.CampaignData) {
				postData.CampaignData.MasterCampaignID = MasterUniqueCodeID;
				postData.CampaignData.MasterPlatformID = PlatformID.toString();
				if (this.state.advertiser !== null) {
					postData.CampaignData.PlatformAdvertiserID = this.state.advertiser.value;
				}
			} else {
				postData.CampaignData = {
					MasterCampaignID: MasterUniqueCodeID,
					MasterPlatformID: PlatformID.toString()
				};
			}

			const permissionedOptions = [];
			Object.keys(this.state.permissionedOptions).forEach((dataKey) => {
				this.state.permissionedOptions[dataKey].forEach((option) => {
					permissionedOptions.push(option.DataValue_MDM_GUID);
				});
			});
			postData.CampaignData.DataValue_MDM_GUIDs = permissionedOptions.join();

			if (this.state.advertiser) {
				postData.CampaignData.PlatformAdvertiserID = this.state.advertiser.value;
			}

			postData.PlatformID = PlatformID.toString();
			// const auditlevelID = filters.auditlevel.value;
			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				MasterRegionCode: contextValues?.region?.name,
				AuditLevelID: this.state.selectedPlatform.HierarchyLevelID,
				ContextID: contextValues.contextId,
				// ParentUniqueIDCode: MasterUniqueCodeID,
				// add here
				...postData
			};

			if (formSubmissionObj?.CampaignData?.KPIGoalDetails?.includes?.("%")) {
				formSubmissionObj.CampaignData.KPIGoalDetails = formSubmissionObj.CampaignData.KPIGoalDetails.replace("%", "");
			}

			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				putFilterData("platform", "");
				MasterCampaignsStore.resetPlatformAdvertisers();

				ErrorHelpers.resetErrors(formEl);
				this.setState({
					formData: {},
					postData: {},
					errors: {},
					showErrors: false,
					advertiser: null,
					isFormDataValid: false,
					selectedPlatform: null,
					activationConfig: [],
					isDataKeyFieldsLoaded: false,
					permissionedOptions: {}
				});
			});
		}
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState }, () => {
			if (this.state.open) {
			} else {
				this.props?.onClose?.();
			}
		});
	};
	/* END */

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				/* Server Side Validation */
				this.sendPostObject(this.state.formData);
			});
		}
	};

	advertiserChange = (optionSelected) => {
		this.setState({ advertiser: optionSelected });
	};

	getActivationPlatformOptions = () => {
		const options = [];
		if (Array.isArray(this.props.availablePlatforms)) {
			this.props.availablePlatforms.forEach((x) => {
				options.push({ value: x.MasterPlatformID, label: x.PlatformName, ...x });
			});
		}

		return options.filter((x) => x.label !== this.state.selectedPlatform?.label);
	};

	handlePlatformChange = (selectedPlatform) => {
		this.setState({
			formData: {},
			postData: {},
			errors: {},
			showErrors: false,
			advertiser: null,
			isFormDataValid: false,
			loading: true,
			selectedPlatform,
			activationConfig: []
		});
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		const isDataKeyFieldsLoaded = !this.state.isDataKeyFieldsLoaded ? "no-data-key-fields" : "";
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		const filters = BookFiltersStore.getChoicesState();
		const platformName = filters.platform.label;
		let formInnards;

		if (Object.keys(this.state.activationConfig).length !== 0) {
			formInnards = (
				<FormBuilderV2
					type="create activationplatform"
					data={this.state.activationConfig}
					configName="ActivationPlatform"
					onUpdate={this.updateState}
					state={this.state}
					// fieldsDisabled={advertiserSelected}
				/>
			);
		} else {
			formInnards = (
				<div>
					{/* <TextInputSkeleton />
					<br />
					<TextInputSkeleton hideLabel /> */}
				</div>
			);
		}

		// let advertiserName = null;
		// MasterCampaignsStore.getData().forEach(masterCampaign => {
		// 	if (parseInt(this.props.selectedMasterCampaignID, 10) === masterCampaign.MasterCampaignUniqueIDCode) {
		// 		Object.keys(masterCampaign.Advertisers).forEach(advertiserNames => {
		// 			if (masterCampaign.Advertisers[advertiserNames].length !== 0) {
		// 				if (parseInt(masterCampaign.Advertisers[advertiserNames][0].MasterPlatformID, 10) === this.props.selectedPlatformID) {
		// 					advertiserName = masterCampaign.Advertisers[advertiserNames][0].Advertisername;
		// 				}
		// 			}
		// 		});
		// 	}
		// });

		return (
			<>
				<Modal
					id="New_activation__campaign"
					className={`master--campaign ${isDisabled} ${isDataKeyFieldsLoaded}`}
					heading="Add Activation Campaign"
					description="Select a platform and the content will refresh automatically."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-create-activation-platform">
									Cancel
								</Button>
								<Button
									display="primary"
									onClick={this.handleSubmit}
									disabled={!this.state.isFormDataValid}
									data-tracking-id-alt="confirm-create-activation-platform"
								>
									Add
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}

					<form autoComplete="off" className="activation-campaign-fields-container">
						<Dropdown
							className={"select-activation-platform-dropdown"}
							id={"activation-platform"}
							name="activation-platform"
							required={true}
							placeholder={"Select Platform"}
							options={this.getActivationPlatformOptions()}
							onChange={(selectedOption) => {
								this.handlePlatformChange(selectedOption);
							}}
							value={this.state.selectedPlatform}
							isSearchable={true}
						>
							Activation Platform
						</Dropdown>
						<AccessPermissions
							type="activation"
							permissionedOptions={this.state.permissionedOptions}
							masterCampaign={this.props.masterCampaign}
							onChange={(value, dataKey) => {
								const { permissionedOptions } = this.state;
								permissionedOptions[dataKey] = value;
								this.setState({ permissionedOptions }, () => {
									this.isValidFormData();
								});
							}}
						/>
						<div className={`platform-fields ${this.state.selectedPlatform ? "" : "hidden"}`}>{formInnards}</div>
						{this.state.showErrors && <div id="errors__container" />}

						{MasterCampaignsStore.getPlatformAdvertisers()?.length && this.state.selectedPlatform && this.state.selectedPlatform?.MasterPlatformID !== 5 ? (
							<div>
								<hr />
								<Dropdown
									onChange={this.advertiserChange}
									placeholder="Select Platform Advertiser"
									options={MasterCampaignsStore.getPlatformAdvertisers()}
									isClearable={false}
									value={this.state.advertiser}
									isSearchable={true}
								>
									<>Advertiser {this.state.selectedPlatform ? ` (${this.state.selectedPlatform?.label})` : ""}</>
								</Dropdown>
							</div>
						) : (
							<></>
						)}
					</form>
				</Modal>
			</>
		);
	}
}

export default withRouter(CreateActivationPlatform);
